import React, { Component } from 'react'
import { Provider } from 'react-redux'
import trans from 'trans'
import store from 'store'

import {
    checkProjectElements,
} from "app/helpers/api"

import { AxiosResponse } from "axios";

import {
    modal,
    Icon,
} from '@bdfx/mergado-ui-kit'

import CheckElementsModalWrapper from './check-elements-modal-wrapper';

export type CheckElementsProjectType = {
    column: string
    originalValue: string
    newValue: string
    isSelected: boolean
}

export type CheckElementsShapeType = {
    shape_id: number
    template_id: number
    column: string
    type: string
    originalValue: string
    newValue: string
    isSelected: boolean
}

export type CheckElementsType = {
    project: CheckElementsProjectType[]
    shapes: CheckElementsShapeType[]
    project_id: number
}

interface Props {
    hideCheckElements: Function
}

interface State {
}

class CheckElementsModal extends Component<Props, State> {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        checkProjectElements()
            .then((response: AxiosResponse<CheckElementsType>) => {
                if (response.data.project.length > 0 || response.data.shapes.length > 0) {
                    modal({
                        overlayClassName: 'check-elements-modal',
                        title: <Icon type={'settings-light'} size={28} text={trans("check_elements_title")} />,
                        message: (close) => <Provider store={store}>
                            <CheckElementsModalWrapper
                                suggestedChanges={response.data}
                                close={close}
                                hideCheckElements={this.props.hideCheckElements}
                            />
                        </Provider>,
                        onClose: (e) => this.props.hideCheckElements(),
                    })
                }
            })
            .catch(e => console.error('check project elements error', e))
    }

    render() {
        return (<></>)
    }
}

export default CheckElementsModal